import { render, staticRenderFns } from "./AdminDealerOrders.vue?vue&type=template&id=27991be6&scoped=true"
import script from "./AdminDealerOrders.vue?vue&type=script&lang=js"
export * from "./AdminDealerOrders.vue?vue&type=script&lang=js"
import style0 from "./AdminDealerOrders.vue?vue&type=style&index=0&id=27991be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27991be6",
  null
  
)

export default component.exports